import { FC } from 'react';

import { useDialog } from 'hooks/useDialog';

import DokumentationsresursPresentationModal from 'components/dokumentationsresursPresentationModal/DokumentationsresursPresentationModal';
import SkeletonImage from 'components/skeleton/SkeletonImage';
import SkeletonItem from 'components/skeleton/SkeletonItem';

import { BildResursData, RitningResursData } from 'models';

import { formatDate } from 'utilities/dateUtilities';

export const MellanlagerResurs: FC<{ resurs: BildResursData | RitningResursData }> = ({ resurs }) => {
  const { setDialog, unsetDialog } = useDialog();

  return (
    <>
      <button
        className="tw-relative tw-box-border tw-block tw-h-32 tw-w-full tw-overflow-hidden tw-border-4 tw-border-b-0 tw-border-raa-green"
        onClick={() => {
          setDialog(DokumentationsresursPresentationModal, { resurs, onClose: () => unsetDialog() });
        }}
      >
        <SkeletonImage
          className="tw-w-full tw-object-cover"
          skeletonClassNames="tw-w-full"
          src={`${process.env.PUBLIC_URL}/api/${resurs?.thumbnailUrl}`}
          alt={`Uppladdad bild för utkast ${resurs?.titel}`}
        />
        <span className="tw-absolute tw-bottom-0 tw-block tw-w-full tw-bg-raa-green tw-py-1 tw-text-center tw-text-size-0.813 tw-text-raa-white">
          Utkast
        </span>
      </button>
      {resurs?.titel === undefined && <SkeletonItem classNames="tw-h-6 tw-w-20 tw-mt-2" rounded="md" />}
      {resurs?.titel && <p className="tw-mt-1 tw-break-words tw-text-size-0.813">{resurs?.titel}</p>}
      {resurs?.titel && <p className="tw-text-size-0.813">{formatDate(resurs?.tillkomstdatum)}</p>}
    </>
  );
};
